export default __webpack_public_path__ + "static/media/menuTwitter.1f19eca1.svg";